import styled from "styled-components";
import Tabela2 from "../../../Componentes/Utils/Tabela2";
import { useEffect, useState } from "react";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { useModal } from "../../../contexts/ModalContext";
import Overlay from "../../../Componentes/Overlay";
import SideMenu from "../../../Componentes/SideMenu";
import SideMenuBtn from "../../../Componentes/SideMenuBtn";
import ModalNewMeta from "./ModalNewMeta";
import axios from "axios";
import MultiselectCheck from "../../../Componentes/Utils/MultiselectCheck";

const Container = styled.div`
    width: 100%;
    height: 100%;
    flex-direction: column;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-y: auto;
`
const ContainerDatas = styled.div`
    width: 210px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    margin-left: auto;
    p{
        margin: 0;
    }
`
const IconeSetaEsquerda = styled(MdOutlineKeyboardArrowLeft)`
    width: 20px;
    height: 20px;
    cursor: pointer;
`
const IconeSetaDireita = styled(MdOutlineKeyboardArrowLeft)`
    width: 20px;
    height: 20px;
    cursor: pointer;
    transform: rotate(180deg);
`
const CelulaDatas = styled.td`
    width: 220px;
`
const CellTable = styled.td`
    white-space: nowrap;
`
const ContainerPercentual = styled.div`
    width: 100%;
    height: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
`
const PercentualBar = styled.div`
    height: 4px;
    width: 110px;
    background-color: #cfcfcf;
    border-radius: 10px;
    margin: 2px 5px 0 0;
    overflow: hidden;
`
const PercentualFill = styled.div`
    height: 100%;
    width: ${props => props.percentual}%;
    background-color: ${props => props.percentual === 100 ? '#4caf50' : props.percentual >= 50 ? '#ffeb3b' : '#f44336'};
`
const PercentualText = styled.p`
    margin: 0;
    font-size: 12px;
    margin-left: auto;
    margin-right: 15px;
`
const InputFiltro = styled.input`
    width: ${props => props.largura ? props.largura : '100%' };
    height: 34px;
    box-sizing: border-box;
    padding: 6px 8px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    border: 1px solid #ddd;
    outline: none;
    &:focus {
        border-color: #007bff;
        box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
    }
    margin: 0;
`

const Content = () => {

    const { isModalOpen, closeModal, openModal } = useModal();

    const [loading, setLoading] = useState(false);

    const [offset, setOffset] = useState(0);

    const calcularSemana = () => {
        const base = new Date();
        base.setDate(base.getDate() + offset * 7);

        const diaSemana = base.getDay();
        const diffParaSegunda = (diaSemana === 0 ? -6 : 1 - diaSemana)

        const segunda = new Date(base);
        segunda.setDate(base.getDate() + diffParaSegunda);

        const domingo = new Date(segunda);
        domingo.setDate(segunda.getDate() + 6);

        return { segunda, domingo };
    }

    const { segunda, domingo } = calcularSemana();

    const openNewMetaModal = (obj) => {

        obj && setSelectedMeta(obj);

        closeModal();
        openModal("newMetaDesvio");

    }

    const [metas, setMetas] = useState([]);
    const [metasFiltered, setMetasFiltered] = useState([]);

    const fetchMetas = async () => {

        setLoading(true);

        try {

            const { data } = await axios.get(`https://sistemaintegrado.palmont.com.br/Painel/API/Desvios/GetMetas/index.php?data_inicio=${segunda.toISOString()}&data_fim=${domingo.toISOString()}`, {
                withCredentials: true
            });

            setMetas(data);
            console.log(data);

        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }

    }

    useEffect(() => {

        fetchMetas();

    }, [offset]);

    const fecharAddModal = () => {
        setSelectedMeta(null);
        closeModal();
    }

    const [selectedMeta, setSelectedMeta] = useState(null);

    const [matriculaFilter, setMatriculaFilter] = useState('');
    const [selectedUser, setSelectedUser] = useState([]);
    const [selectedFuncao, setSelectedFuncao] = useState([]);
    const [selectedCentroCusto, setSelectedCentroCusto] = useState([]);
    const [emailFilter, setEmailFilter] = useState('');

    //remover duplicados e coloca em formato label value
    const userOptions = [...new Set(metas.map(meta => meta.usuario))].sort().map(user => ({ label: user, value: user }));
    const funcaoOptions = [...new Set(metas.map(meta => meta.funcao))].sort().map(funcao => ({ label: funcao, value: funcao }));
    const centroCustoOptions = [...new Set(metas.map(meta => meta.centro_custo))].sort().map(cc => ({ label: cc, value: cc }));

    useEffect(() => {

        let filtered = metas;

        if (matriculaFilter.trim() !== ''){
            filtered = filtered.filter(meta => meta.matricula.toString().includes(matriculaFilter.trim()));
        }
        if (selectedUser.length > 0) {
            filtered = filtered.filter(meta => selectedUser.includes(meta.usuario));
        }
        if (selectedFuncao.length > 0) {
            filtered = filtered.filter(meta => selectedFuncao.includes(meta.funcao));
        }
        if (selectedCentroCusto.length > 0) {
            filtered = filtered.filter(meta => selectedCentroCusto.includes(meta.centro_custo));
        }
        if (emailFilter.trim() !== ''){
            filtered = filtered.filter(meta => meta.email.toLowerCase().includes(emailFilter.trim().toLowerCase()));
        }

        setMetasFiltered(filtered);

    }, [ matriculaFilter, selectedUser, selectedFuncao, selectedCentroCusto, emailFilter, metas ]);

    return (
        <>
            <Container>
                <Tabela2>
                    <thead>
                        <tr>
                            <th colSpan={6} >METAS DESVIO</th>
                            <CelulaDatas>
                                <ContainerDatas>
                                    <IconeSetaEsquerda onClick={() => setOffset(offset - 1)} />
                                    <p>{segunda.toLocaleDateString()} - {domingo.toLocaleDateString()}</p>
                                    <IconeSetaDireita onClick={() => setOffset(offset + 1)} />
                                </ContainerDatas>
                            </CelulaDatas>
                        </tr>
                        <tr>
                            <th>MATRICULA</th>
                            <th>USUÁRIO</th>
                            <th>FUNÇÃO</th>
                            <th>CENTRO CUSTO</th>
                            <th>E-MAIL</th>
                            <th>META</th>
                            <th>CONCLUSÃO</th>
                        </tr>
                        <tr>
                            <td>
                                <InputFiltro
                                    placeholder="FILTRAR..."
                                    value={ matriculaFilter }
                                    onChange={e => setMatriculaFilter(e.target.value)}
                                    maxLength={6}
                                    largura="220px"
                                />
                            </td>
                            <td>
                                <MultiselectCheck
                                    options={userOptions}
                                    selectedOptions={selectedUser}
                                    setSelectedOptions={setSelectedUser}
                                    largura="220px"
                                />
                            </td>
                            <td>
                                <MultiselectCheck
                                    options={funcaoOptions}
                                    selectedOptions={selectedFuncao}
                                    setSelectedOptions={setSelectedFuncao}
                                    largura="220px"
                                />
                            </td>
                            <td>
                                <MultiselectCheck
                                    options={centroCustoOptions}
                                    selectedOptions={selectedCentroCusto}
                                    setSelectedOptions={setSelectedCentroCusto}
                                    largura="220px"
                                />
                            </td>
                            <td>
                                <InputFiltro
                                    placeholder="FILTRAR..."
                                    value={ emailFilter }
                                    onChange={e => setEmailFilter(e.target.value)}
                                    largura="220px"
                                />
                            </td>
                            <td></td>
                            <td></td>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={7} >
                                    CARREGANDO...
                                </td>
                            </tr>
                        ) : (
                            metasFiltered.map((meta) => {
                                let percentual = 0;

                                if (meta.realizados > 0) {
                                    percentual = (meta.realizados / meta.meta) * 100;
                                }

                                return (
                                    <tr key={meta.id} onClick={() => openNewMetaModal(meta)} >
                                        <CellTable>{meta.matricula}</CellTable>
                                        <CellTable>{meta.usuario}</CellTable>
                                        <CellTable>{meta.funcao}</CellTable>
                                        <CellTable>{meta.centro_custo}</CellTable>
                                        <CellTable>{meta.email}</CellTable>
                                        <CellTable>{meta.realizados} / {meta.meta}</CellTable>
                                        <CellTable>
                                            <ContainerPercentual>
                                                <PercentualBar>
                                                    <PercentualFill percentual={percentual} />
                                                </PercentualBar>
                                                <PercentualText>{percentual.toFixed(2)}%</PercentualText>
                                            </ContainerPercentual>
                                        </CellTable>
                                    </tr>
                                )
                            })
                        )}
                    </tbody>
                </Tabela2>
            </Container>
            {
                isModalOpen("sidebarMetasDesvios") && (
                    <Overlay state={true} changeContent={closeModal} >
                        <SideMenu>
                            <SideMenuBtn
                                button="ADICIONAR META"
                                clickFunc={() => openNewMetaModal(null)}
                            />
                        </SideMenu>
                    </Overlay>
                )
            }
            {
                isModalOpen("newMetaDesvio") && (
                    <ModalNewMeta
                        fecharModal={fecharAddModal}
                        updateMetas={fetchMetas}
                        selectedMeta={selectedMeta}
                    />
                )
            }
        </>
    )
}

export default Content;